import React, { useContext, useEffect, useState } from "react";
import "../Components/Tickets/Tickets.css";
import { useNavigate } from "react-router";
import { techappContext } from "../../Api/techappReq";
import Colors from "../../Helper/Colors";
import uploadIcon from "../../assets/images/upload.png";
import recordIcon from "../../assets/images/mic.png";
import stopIcon from "../../assets/images/stop.png";
import { Select, Input, Button } from "antd";
import { toast } from "react-toastify";
import Modal from "react-modal";
import cameraIcon from "../../assets/images/camera.png";
import galleryIcon from "../../assets/images/gallery.png";
import Camera from "../Components/camera";
import generateKey from "../../utils/generate_key";
import Header from "../Components/header";
import { useAudioRecorder } from "react-audio-voice-recorder";
import Layout from "../../layout";
import { FaTimes } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
const { Option } = Select;
const { TextArea } = Input;

const CreateTicket = () => {
  const navigate = useNavigate();
  const {
    ticketCat,
    catsItem,
    loading,
    setCreateTicketOrderId,
    createTicketOrderId,
  } = useContext(techappContext);

  const {
    startRecording,
    stopRecording,
    recordingBlob,
    isRecording,
    recordingTime,
  } = useAudioRecorder();

  const { postTicketReq } = useContext(techappContext);

  const [titles, setTitles] = useState(null);
  const [firstTitle, setFirstTitle] = useState(null);
  const [secondTitle, setSecondTitle] = useState(null);
  const [des, setDes] = useState("");
  const [catId, setCatId] = useState(null);
  const [inp, setInp] = useState(null);
  const [imageList, setImageList] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [showDoc, setShowDoc] = useState(false);
  const [doc, setDoc] = useState(null);
  const [isImageList, setIsImageList] = useState(false);
  const [pickModal, setPickModal] = useState(false);
  const [isCamera, setIsCamera] = useState(false);
  const [voices, setVoices] = useState([]);

  // const addAudioElement = (blob) => {
  //   const url = URL.createObjectURL(blob);
  // };

  const selectPart = (value) => {
    setFirstTitle(value);
    setSecondTitle(null);
    catsItem.forEach((item) => {
      if (item.name === value) {
        setCatId(item.id);
        if (item.questions.length > 0) {
          setTitles(item.questions);
        } else if (item.questions.length === 0) {
          setTitles(null);
          setSecondTitle(null);
        }
      }
    });
  };

  const upload = (e) => {
    let list = [];
    for (var i = 0; i < e.target.files.length; i++) {
      list.push(e.target.files[i]);
      fileList.push(e.target.files[i]);
    }
    list.forEach((li) => {
      imageList.push(URL.createObjectURL(li));
    });
    setIsImageList(true);
  };

  const removeFileHandler = (url, index) => {
    setImageList(imageList.filter((img) => img !== url));
    setFileList(
      fileList.filter((file, i) => {
        return i !== index;
      })
    );
  };

  const onPreview = async (file) => {
    setDoc(file);
    setShowDoc(true);
  };

  const submitSend = () => {
    if (firstTitle === null) {
      toast.warning("لطفا بخش تیکت را انتخاب کنید");
    } else if (titles && secondTitle === null) {
      toast.warning("لطفا موضوع تیکت را انتخاب کنید");
    } else if (des.length === 0) {
      toast.warning("توضیحات نباید خالی باشد");
    } else if (des.length < 6) {
      toast.warning("توضیحات نباید کمتر از ۶ حرف باشد");
    } else {
      postTicketReq(firstTitle, secondTitle, des, catId, fileList, voices);
    }
  };

  useEffect(() => {
    ticketCat();
  }, []);

  useEffect(() => {
    setIsImageList(false);
  }, [isImageList]);

  useEffect(() => {
    if (recordingBlob) {
      voices.push({
        key: generateKey(),
        file: recordingBlob,
        url: window.URL.createObjectURL(recordingBlob),
      });
    }
  }, [recordingBlob]);

  return (
    <Layout>
      <div className="techapp-create-ticket">
        <Header
          title={"ایجاد تیکت"}
          backHandler={() => {
            navigate("/techapp/tickets");
          }}
        />
        <div className="techapp-create-ticket-body">
          {/* topic */}
          <Select
            showSearch
            dropdownStyle={{ textAlign: "right" }}
            className="techapp-select-border-radius"
            placeholder={"انتخاب بخش"}
            value={firstTitle}
            onChange={(value) => selectPart(value)}
          >
            {catsItem &&
              catsItem.length > 0 &&
              catsItem.map((item, index) => (
                <Option id={`topic_${index}`} key={item.id} value={item.name}>
                  {item.name}
                </Option>
              ))}
          </Select>
          {/* titles */}
          {titles && titles.length > 0 && (
            <Select
              showSearch
              dropdownStyle={{ textAlign: "right" }}
              className="techapp-select-border-radius"
              placeholder={"انتخاب موضوع"}
              value={secondTitle}
              onChange={(value) => setSecondTitle(value)}
              rootClassName="create_ticket_title_select"
            >
              {titles &&
                titles.length > 0 &&
                titles.map((title, index) => (
                  <Option
                    id={`title_${index}`}
                    key={index}
                    value={title.question}
                  >
                    {title.question}
                  </Option>
                ))}
            </Select>
          )}
          {/* description */}
          <div style={{ width: "90%", position: "relative" }}>
            <TextArea
              placeholder={"توضیحات"}
              style={{
                paddingTop: "5px",
                maxHeight: "120px",
                borderRadius: "5px",
              }}
              id="create_ticket_description"
              autoSize
              onChange={(e) => setDes(e.target.value)}
            />
            <button
              style={{
                cursor: "pointer",
                position: "absolute",
                left: "10px",
                bottom: "10px",
                zIndex: 999,
                backgroundColor: "transparent",
                border: "none",
              }}
              onClick={() => {
                if (isRecording) {
                  stopRecording();
                } else {
                  startRecording();
                }
              }}
            >
              {isRecording && (
                <span style={{ marginLeft: "10px", color: "gray" }}>
                  {recordingTime} ثانیه
                </span>
              )}
              <img
                src={isRecording ? stopIcon : recordIcon}
                alt="record"
                style={{ width: "20px" }}
              />
            </button>
          </div>
          {/* order id */}
          <TextArea
            style={{
              width: "90%",
              maxHeight: "120px",
              paddingTop: "5px",
              borderRadius: "5px",
            }}
            autoSize
            placeholder={"شماره سفارش یا مشخصات مشتری (اختیاری)"}
            value={createTicketOrderId}
            onChange={(e) => setCreateTicketOrderId(e.target.value)}
            id="create_ticket_order_id"
          />
          {/* uploaded files preview */}
          <div className="techapp-create-ticket-filelist-show">
            {imageList.length > 0 &&
              imageList.map((url, index) => (
                <div style={{ position: "relative" }}>
                  <img
                    onClick={() => onPreview(url)}
                    src={url}
                    id="image-uploaded"
                    key={index}
                    className="techapp-define-cost-upload-image"
                    alt={'image'+index}
                  />
                  <span
                    onClick={() => removeFileHandler(url, index)}
                    className="techapp-upload-remove-btn"
                  >
                    x
                  </span>
                </div>
              ))}
          </div>
          {/* recorded voices preview */}
          {voices?.length > 0 &&
            voices.map((voice) => (
              <div
                style={{
                  position: "relative",
                  width: "unset",
                }}
              >
                <audio src={voice.url} controls />
                <span
                  onClick={() =>
                    setVoices(voices.filter((vc) => vc.key !== voice.key))
                  }
                  style={{ left: "-5px" }}
                  className="techapp-upload-remove-btn"
                >
                  x
                </span>
              </div>
            ))}
          {/* action area */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "auto",
              marginBottom: "0",
            }}
          >
            <Button
              style={{ backgroundColor: Colors.royalBlue, marginTop: "0" }}
              className={`tech-app-operation-button btn-text-white ${
                isRecording ? "w-100" : ""
              }`}
              onClick={() => {
                if (isRecording) {
                  toast.warning("شما در حال ظبط صدا میباشید");
                } else {
                  submitSend();
                }
              }}
              loading={loading}
              id="create_ticket_submit_btn"
            >
              {isRecording ? "در حال ظبط صدای شما" : "ثبت تیکت"}
            </Button>
            {!isRecording && (
              <div
                className="techapp-create-ticket-upload-btn"
                onClick={() => setPickModal(true)}
              >
                <img src={uploadIcon} alt="upload" style={{ width: "24px" }} />
                <input
                  onChange={upload}
                  type="file"
                  name="filefield"
                  multiple="multiple"
                  style={{ display: "none" }}
                  ref={(fileInput) => setInp(fileInput)}
                />
              </div>
            )}
          </div>
          {/* preview modal */}
          {showDoc && doc && (
            <Modal
              ariaHideApp={false}
              isOpen={true}
              onRequestClose={() => setShowDoc(false)}
              className="tech-app-view-order-showdoc-modal"
              style={{
                overlay: {
                  backgroundColor: "rgba(0, 0, 0)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: "100000",
                },
              }}
            >
              <FaTimes
                onClick={() => setShowDoc(false)}
                style={{
                  color: "white",
                  cursor: "pointer",
                  position: "absolute",
                  right: "30px",
                  top: "20px",
                  fontSize: "22px",
                }}
              />
              <img
                style={{ width: "100%", height: "100%" }}
                src={doc}
                alt="doc"
              />
            </Modal>
          )}
          {/* pick modal */}
          <Modal
            ariaHideApp={false}
            isOpen={pickModal}
            onRequestClose={() => setPickModal(false)}
            className="tech-app-view-order-modal"
            style={{
              overlay: {
                backgroundColor: "rgba(0, 0, 0, 0.551)",
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-end",
                zIndex: "10000",
              },
            }}
          >
            <p style={{ padding: "10px", marginBottom: "20px" }}>
              <IoIosArrowDown
                style={{ cursor: "pointer", padding: "0 10px" }}
                onClick={() => setPickModal(false)}
              />
              <span>انتخاب عکس</span>
            </p>
            <div
              onClick={() => {
                inp.click();
                setPickModal(false);
              }}
              style={{
                color: "black",
                display: "flex",
                alignItems: "center",
                padding: "15px 10px",
                marginBottom: "20px",
              }}
            >
              <img
                src={galleryIcon}
                alt="icon"
                style={{ width: "20px", marginLeft: "10px" }}
              />
              گالری
            </div>
            <div
              onClick={() => {
                if (window.outerWidth > 800) {
                  toast.warning(
                    "برای استفاده از دوربین باید از موبایل استفاده کنید"
                  );
                } else {
                  setIsCamera(true);
                  setPickModal(false);
                }
              }}
              style={{
                color: "black",
                display: "flex",
                alignItems: "center",
                padding: "15px 10px",
                marginBottom: "20px",
              }}
            >
              <img
                src={cameraIcon}
                alt="icon"
                style={{ width: "20px", marginLeft: "10px" }}
              />
              دوربین
            </div>
          </Modal>
          {/* camera modal */}
          <Modal
            ariaHideApp={false}
            isOpen={isCamera}
            onRequestClose={() => setPickModal(false)}
            className="tech-app-view-order-modal h-100"
            style={{
              overlay: {
                backgroundColor: "rgba(0, 0, 0, 0.551)",
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-end",
                zIndex: "10000",
              },
            }}
          >
            <Camera
              modal={setIsCamera}
              fileList={fileList}
              imageList={imageList}
            />
          </Modal>
        </div>
      </div>
    </Layout>
  );
};
export default CreateTicket;
